export default __webpack_public_path__ + "static/media/ico_map_blue.74ff2f38.svg";